import React, { Fragment, useEffect, useState } from 'react'
import { Stack } from '@mui/material'
import { useApi } from '../../hooks/useApi'
import { ApiResponse } from '../../typings/ApiResponse'
import axios from 'axios'
import { ApiConfig } from '../../config/api'
import { WorkOrderBlogTable } from './WorkOrderBlogTable'
import { WorkOrderBlog } from '../../interfaces/WorkOrder/WorkOrderBlog'
import { WorkOrderBlogForm } from './WorkOrderBlogForm'
import { Status } from '../../hooks/useFetchState'
import { GenericOrderBy, getNewDirection } from '../_EOS/Table'

interface WorkOrderBlogProps {
  workOrderId: number
}

const getWorkOrderBlogs = (
  workOrderId: number,
  page?: number,
  pageSize?: number,
  orderBy?: GenericOrderBy<WorkOrderBlog>
) => {
  const url = new URL(`${ApiConfig.WorkOrderBlog}`)

  url.searchParams.set('pageIndex', page?.toString() || '')
  url.searchParams.set('pageSize', pageSize?.toString() || '')
  url.searchParams.set('workOrderId', workOrderId.toString())

  if (orderBy?.field) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export const WorkOrderBlogComponent: React.FC<WorkOrderBlogProps> = ({
  workOrderId
}) => {
  const { state, callApi } = useApi<ApiResponse<WorkOrderBlog>>()

  const [orderBy, setOrderBy] = useState<GenericOrderBy<WorkOrderBlog>>({
    field: 'createdDate',
    direction: 'asc'
  })

  const requestWorkOrderBlogs = () => {
    callApi(getWorkOrderBlogs(workOrderId, 0, 100, orderBy))
  }

  const handleSorting = ({
    field,
    direction
  }: GenericOrderBy<WorkOrderBlog>) => {
    if (field === orderBy.field) {
      setOrderBy({ field, direction: getNewDirection(orderBy.direction) })
      return
    }

    setOrderBy({ field, direction })
  }

  useEffect(() => {
    requestWorkOrderBlogs()
  }, [orderBy])

  return (
    <Fragment>
      <Stack spacing={2}>
        <WorkOrderBlogTable
          workOrderBlogs={state.data?.items || []}
          isLoading={state.status === Status.Loading}
          orderBy={orderBy}
          onSortChange={handleSorting}
        />
        <WorkOrderBlogForm
          workOrderId={workOrderId}
          getWorkOrderBlogs={requestWorkOrderBlogs}
        />
      </Stack>
    </Fragment>
  )
}
